// @ts-strict-ignore
import React from 'react';
import { Button, Typography } from 'onboarding-components';
import moment from 'moment';
import { SetupGuideContext } from 'common/onboarding/immersive-onboarding-legacy/types';
import { SvgIconReact } from 'common/components/svg-icon';
import { IMMERSIVE_ASSETS } from 'common/onboarding/immersive-onboarding-legacy/assets';
import { Trans } from 'common/i18n';
import { useTranslation } from 'common/i18n/hooks';
import styles from './summary-table.module.styl';
export const SummaryTable: React.FC<{
  onEdit: () => void;
  tableTitle?: string;
}> = _ref => {
  let {
    onEdit,
    tableTitle
  } = _ref;
  const {
    setupGuideInfo
  } = React.useContext(SetupGuideContext);
  const {
    t
  } = useTranslation();
  const {
    eventsPropertiesMap
  } = setupGuideInfo;
  return <table className={styles.container} data-sentry-component="SummaryTable" data-sentry-source-file="summary-table.tsx">
      <thead>
        <tr className={styles.tableHeader} style={{
        backgroundImage: "url(".concat(IMMERSIVE_ASSETS.tableHeaderGradient, ")"),
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat"
      }}>
          <th className={styles.tableTitleSection}>
            <div className={styles.tableTitle}>
              <img className={styles.moniker} src={IMMERSIVE_ASSETS.summaryCheckmark} />
              <Typography variant='headingXs' className={styles.noMargin} data-sentry-element="Typography" data-sentry-source-file="summary-table.tsx">
                {tableTitle ? tableTitle : t("onboarding.table-title")}
              </Typography>
            </div>
            <Typography className={styles.tableSubtitle} variant='captionSm' data-sentry-element="Typography" data-sentry-source-file="summary-table.tsx">
              <Trans i18nKey={"onboarding.planned-edited-by"} t={t} values={{
              modifiedDate: setupGuideInfo !== null && setupGuideInfo !== void 0 && setupGuideInfo.modified ? moment(setupGuideInfo.modified).format("MMM D, YYYY") : "",
              editorName: (setupGuideInfo === null || setupGuideInfo === void 0 ? void 0 : setupGuideInfo.author) || (setupGuideInfo === null || setupGuideInfo === void 0 ? void 0 : setupGuideInfo.email)
            }} components={{
              typograph: <Typography className={styles.boldText} variant='captionSm' weight='bold'>
                      {(setupGuideInfo === null || setupGuideInfo === void 0 ? void 0 : setupGuideInfo.author) || (setupGuideInfo === null || setupGuideInfo === void 0 ? void 0 : setupGuideInfo.email)}
                    </Typography>
            }} data-sentry-element="Trans" data-sentry-source-file="summary-table.tsx" />
            </Typography>
          </th>
          <th>
            <Button variant='inline' includeArrow={false} onClick={onEdit} data-sentry-element="Button" data-sentry-source-file="summary-table.tsx">
              {t("common.edit")}
            </Button>
          </th>
        </tr>
      </thead>
      <tbody className={styles.tableBody}>
        <tr className={styles.tableHeaderRow}>
          <td className={styles.event}>
            <Typography variant='captionSm' weight='bold' data-sentry-element="Typography" data-sentry-source-file="summary-table.tsx">
              {t("mixology.event")}
            </Typography>
          </td>
          <td className={styles.properties}>
            <Typography variant='captionSm' weight='bold' data-sentry-element="Typography" data-sentry-source-file="summary-table.tsx">
              {t("mixology.property")}
            </Typography>
          </td>
        </tr>
        {Object.keys(eventsPropertiesMap).map((event, index) => {
        const properties = eventsPropertiesMap[event];
        return <tr key={"".concat(event, "-row-").concat(index)} className={styles.tableRow}>
              <td className={styles.event}>
                <div className={styles.moniker}>
                  <SvgIconReact icon='event' />
                </div>
                <Typography variant='captionSm' weight='bold'>
                  {event}
                </Typography>
              </td>
              <td className={styles.properties}>
                <Typography variant='captionSm'>{properties.join(", ")}</Typography>
              </td>
            </tr>;
      })}
      </tbody>
    </table>;
};